import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {Formik} from 'formik';
import {useQuery} from '@apollo/client';
import {Paper, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Box} from '@mui/material';
import {Edit} from '@mui/icons-material';
import {RoundTooltipButton, ButtonComponent} from '../../components/mui-button';
import {FIND_ALL_ESTADOS} from '../../graphql/queries';
import InputV2 from '../../components/input-v2/mui-input-v2';
import TableCellOrdered from '../../components/table-cell-ordered';
import inputsEvents from '../../utils/inputsEvents';
import {persistFiltrosEstado, persistEstado} from '../../redux/Estado/slice';

const columns = [
  {id: 'nome', label: 'Nome'},
  {id: 'uf', label: 'UF'},
];

const ConsultaEstados = ({pageSize = 20}) => {
  const {filtrosEstado, totalEstado, estado, refetchEstado} = useSelector(
    (store) => store.Estado,
  );
  const [page, setPage] = useState(filtrosEstado.page);
  const [rowsPerPage] = useState(pageSize);
  const [orderBy, setOrderBy] = useState(filtrosEstado.orderBy);
  const [filtros, setFiltros] = useState(filtrosEstado.filtros);
  const [searchDTO, setSearchDTO] = useState(filtros);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const estadosQuery = useQuery(FIND_ALL_ESTADOS, {
    variables: {
      pageable: {
        pageNumber: page,
        pageSize,
        sortField: orderBy.campo,
        sortDir: orderBy.asc ? 'ASC' : 'DESC',
      },
      searchDTO,
    },
  });

  const refetch = () => {
    setPage(0);
    setSearchDTO(filtros);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  useEffect(() => {
    if (!estadosQuery.loading && !estadosQuery.error && estadosQuery.data) {
      dispatch(persistFiltrosEstado({filtros, page, orderBy}));
      dispatch(persistEstado(estadosQuery.data?.estados || []));
    }
    if (refetchEstado) {
      estadosQuery.refetch();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estadosQuery, dispatch, refetchEstado]);

  return (
    <Grid id="page-container" container>
      <Grid item xs={12} onKeyUp={({key}) => inputsEvents.handleKeyUp(key, refetch)}>
        <Formik initialValues={filtros} enableReinitialize>
          <Paper id="filtro-paper">
            <Grid container spacing={2}>
              <Grid item xs={10}>
                <InputV2
                  label="Nome"
                  value={filtros.search || ''}
                  onChange={(e) =>
                    setFiltros({...filtros, search: e.target.value})
                  }
                />
              </Grid>
              <Grid item xs={2}>
                <ButtonComponent
                  value="Filtrar"
                  loading={estadosQuery.loading}
                  onClick={() => refetch()}
                />
              </Grid>
            </Grid>
          </Paper>
        </Formik>
        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Box overflow="auto">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCellOrdered
                        key={column.id}
                        column={column}
                        orderBy={orderBy}
                        setOrderBy={setOrderBy}
                      />
                    ))}
                    <TableCell id="acoes" key="acoes" align="right">
                      Ações
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {estado.map((row) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.id}>
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.format ? column.format(value) : value}
                            </TableCell>
                          );
                        })}
                        <TableCell align="right">
                          <Grid marginRight="-5px">
                            <RoundTooltipButton
                              id="icon-primary"
                              title={'Editar'}
                              onClick={() => navigate(`${row.id}/editar`)}
                              icon={<Edit />}
                            />
                          </Grid>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
            <TablePagination
              component="div"
              count={totalEstado}
              rowsPerPageOptions={[]}
              rowsPerPage={rowsPerPage}
              page={page}
              backIconButtonProps={{
                'aria-label': 'página anterior',
              }}
              nextIconButtonProps={{
                'aria-label': 'próxima página',
              }}
              labelDisplayedRows={({from, to, count}) =>
                `${from}-${to} de ${count}`
              }
              onPageChange={handleChangePage}
            />
          </TableContainer>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ConsultaEstados;
